import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
// import ContentItem from "../../components/ContentItem";

import MyCouponList from './MyCouponList';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class MyCoupon extends Component {
  state = {
    couponNo: '',
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    dataList: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;

        //const cash = result.data[0].cash;
        const dataList = result.data[0].listData;
        //console.log(dataList)

        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage,
                pageCount: pageCount,
                con: con,
                //cash: cash,
                dataList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                pageCount: 1,
                con: con,

                //cash: cash,
                dataList: [],
                hasMore: pageCount < gotoPage ? false : true,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              pageCount: 1,
              con: con,

              //cash: cash,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/myCouponList',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gotoPage);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gotoPage) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gotoPage === 0) {
        this._onReg();
      } else {
        this._getData(gotoPage);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onChange = (e) => {
    this.setState({
      couponNo: e.target.value,
    });
  };
  _onReg = async () => {
    const { loginId } = this.props;
    const { couponNo } = this.state;

    if (loginId === '' || loginId === undefined || loginId === null) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      if (couponNo === '' || couponNo === undefined || couponNo === null) {
        toast.warn('쿠폰번호를 입력해 주세요.');
      } else {
        //console.log(couponNo)
        const result = await this._onRegApi(couponNo);
        if (result) {
          const intReturn = result.data[0].intReturn;
          //console.log(intReturn)
          if (intReturn === 0) {
            toast.warn('쿠폰이 정상적으로 등록되었습니다.');
            this._getData(1);
          } else if (intReturn === -4) {
            toast.error('이미 사용된 쿠폰번호 입니다.');
          } else if (intReturn === -3) {
            toast.error('유효기간이 만료된 쿠폰입니다.');
          } else if (intReturn === -2) {
            toast.error('쿠폰번호가 잘못되었습니다.');
          } else {
            toast.error('등록중 오류가 발생했습니다.');
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onRegApi = (couponNo) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/myCouponReg',
        {
          params: {
            userid: loginId,
            couponNo: couponNo,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { couponNo, dataList, gotoPage, pageCount, con } = this.state;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab coupon_tit">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>나의 쿠폰{' '}
              </h3>
            )}

            <div className="coupon_regi">
              <p>쿠폰 다운로드를 위해 발급된 코드를 입력해 주세요.</p>
              <dl className="coupon_code">
                <dt>쿠폰코드 입력</dt>
                <dd>
                  <input
                    type="text"
                    name="couponNo"
                    value={couponNo}
                    maxLength={30}
                    onChange={this._onChange}
                    placeholder="공란없이 대/소문자 구분하여 입력('_'포함)"
                  />
                  <button type="button" onClick={this._onReg}>
                    등록
                  </button>
                </dd>
              </dl>
            </div>
          </div>

          <MyCouponList
            dataList={dataList}
            gotoPage={gotoPage}
            pageCount={pageCount}
            con={con}
            _getData={this._getData}
          />
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyCoupon));
